module.exports = __webpack_public_path__ + "img/39.e413730b.png";